module.exports = __webpack_public_path__ + "img/sld_acdb_t1_b1.7ad34769.svg";